import { useTheme } from '@emotion/react'
import {
  Add,
  Lens as Disc,
  Done,
  KeyboardArrowRight,
  Remove,
} from 'emotion-icons/material'
import * as React from 'react'

import * as Styled from './List.styles'

const ListItem = ({
  children = null,
  content = null,
  icon = <Disc size="0.5em" style={{ marginTop: '0.45em' }} />, // This icon gets overridden by the theme file
  inPackageCard = false,
  listIcon = null, // This icon gets overridden by existing as a prop
  ...props
}) => {
  const { components } = useTheme()

  let renderedIcon = listIcon

  if (!listIcon) {
    switch (components?.ListItem?.icon) {
      case 'Lens':
        renderedIcon = icon
        break
      case 'Done':
        renderedIcon = <Done />
        break
      case 'Add':
        renderedIcon = <Add />
        break
      case 'Remove':
        renderedIcon = <Remove />
        break
      case 'KeyboardArrowRight':
        renderedIcon = <KeyboardArrowRight />
        break
      default:
        renderedIcon = icon
        break
    }
  }

  if (inPackageCard && components?.PackageCard?.hideIcons) {
    renderedIcon = null
  }

  return (
    <Styled.ListItem
      className="leshen-list-item"
      icon={renderedIcon && true}
      {...props}
    >
      {renderedIcon && renderedIcon}

      {content && <div>{content}</div>}
      {children && <div>{children}</div>}
    </Styled.ListItem>
  )
}

export default ListItem
